<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>

      <div style="margin-bottom: 10px">
        <el-tabs v-model="query.reconType" @tab-click="tabClick" stretch style="width: 30%">
          <el-tab-pane v-for="item in reconciliationStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <!-- <el-badge :value="item.count" :max="99" class="item"> -->
              <span style="margin: 0 10px"> {{ item.name }} </span>
              <!-- </el-badge> -->
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="header">
        <div class="left">
          <el-button type="primary" class="btn primary" @click="reviewEvt" v-loading="reviewLoading"
            :disabled="reviewLoading">异常复核</el-button>
          <el-button type="primary" class="btn primary" @click="reconciliationEvt">立即对账</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div>对账截止时间：{{tableTotalData.lastEndTime}}</div>
        </div>
      </div>
      
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe 
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column label="单据时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.tableCreatedTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="库房" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" width="100" prop="tableTypeName" label="单据类型"></el-table-column>
        <el-table-column prop="tableNo" :show-overflow-tooltip="true" width="120" label="单据编号"></el-table-column>
        <el-table-column prop="supplierProductNo" :show-overflow-tooltip="true" width="120"
          label="供应商产品编码"></el-table-column>
        <el-table-column prop="productName" :show-overflow-tooltip="true" width="120" label="产品名称"></el-table-column>
        <el-table-column prop="specName" :show-overflow-tooltip="true" width="120" label="规格型号"></el-table-column>
        <el-table-column prop="manufacturerName" :show-overflow-tooltip="true" width="120"
          label="生产厂家"></el-table-column>
        <el-table-column prop="unit" :show-overflow-tooltip="true" width="120" label="单位"></el-table-column>
        <el-table-column prop="price" :show-overflow-tooltip="true" width="120" label="价格"></el-table-column>
        <el-table-column prop="batch" :show-overflow-tooltip="true" width="120" label="批次号"></el-table-column>
        <el-table-column prop="serialNo" :show-overflow-tooltip="true" width="120" label="序列号"></el-table-column>
        <el-table-column prop="mainNo" :show-overflow-tooltip="true" width="120" label="主条码"></el-table-column>
        <el-table-column prop="traceNo" :show-overflow-tooltip="true" width="120" label="追溯码"></el-table-column>
        <el-table-column prop="tableNumber" fixed="right" width="120" label="单据数量"></el-table-column>
        <el-table-column prop="tableAmount" fixed="right" width="120" label="单据金额"></el-table-column>
        <el-table-column prop="inOutNumber" fixed="right" width="120" label="流水数量"></el-table-column>
        <el-table-column prop="inOutAmount" fixed="right" width="120" label="流水金额"></el-table-column>
        <el-table-column prop="numberDiffer" fixed="right" width="120" label="数量差异"></el-table-column>
        <el-table-column prop="amountDiffer" fixed="right" width="120" label="金额差异"></el-table-column>
      </el-table>
       <div class="tableTotal"> 
        <span style="flex:9;padding-left: 10px">差异汇总</span>
        <div>
          <span>数量差异：{{tableTotalData.diffNumSum}}</span>
          <span>金额差异：{{tableTotalData.diffAmouSum}}</span>
        </div>
      </div>
    </div>
     
    <div class="pagination">
      <!-- <span style="float: left">勾选金额合计：{{ totalAmount }}元</span> -->
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog title="对账时间段选择"  :visible.sync="dialogVisible" width="30%" :before-close="closeDialog">
      <el-form ref="form" :model="form" label-width="150px" >
        <el-form-item label="对账开始时间：">
          <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" @change="handleStartTimeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="对账结束时间：">
          <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" :picker-options="endTimePickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetReconciliationDataList,
  ReviewRecoData,
  CreateReconciliation,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  InOutTableTypeOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetReconciliationDataList,
      filterOptions: [
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "单据时间",
          type: "date",
          code: "date",
        },
        {
          name: "单据类型",
          type: "select",
          code: "TableTypes",
          multiple: true,
          data: InOutTableTypeOptions,
        },
           {
          name: "单据编号",
          type: "input",
          code: "tableNo",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
      ],
      reconciliationStateArray: [
        {
          id: 1,
          name: "按单据核对",
          count: 0,
        },
        {
          id: 2,
          name: "按流水核对",
          count: 0,
        },
      ],
      reviewLoading: false,
      dialogVisible: false,
      form: {
        startDate: '',
        endDate: '',
      },
       endTimePickerOptions: {
        disabledDate: (time) => {
          if (this.form.startDate) {
            const startDate = new Date(this.form.startDate);
            const maxDate = new Date(startDate);
            maxDate.setMonth(startDate.getMonth() + 1);
            return time.getTime() < startDate.getTime() || time.getTime() > maxDate.getTime();
          }
          return false;
        }
      },
      tableTotalData:{},
    };
  },
  methods: {
    tabClick(tab) {
      this.query.reconType = tab.name;
      this.query.pageIndex = 1;
      this.$refs.multipleTable.clearSelection()
      this.getData();
    },
    reviewEvt() {
      this.reviewLoading = true;
      this.loading = true;
      ReviewRecoData({
        ids: this.ids,
      }).then(res => {
           this.$refs.multipleTable.clearSelection()
        this.$message({
          message: "复核成功",
          type: "success",
        });
        this.reviewLoading = false;
        this.getData()
      }).catch(() => {
        this.reviewLoading = false;
        this.loading = false;
      });
    },
    reconciliationEvt() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.form = {
        startDate: '',
        endDate: '',
      }
    },
    submitForm() {
      this.loading = true;

      if(!this.form.startDate || !this.form.endDate) {
        this.$message({
          message: "请选择对账时间",
          type: "warning",
        });
         this.loading = false
        return;
      }
            this.dialogVisible = false;
      CreateReconciliation(this.form).then(res => {
        this.loading = false;
        this.closeDialog()
          this.$refs.multipleTable.clearSelection()
        this.getData()
      }).catch(() => {
        this.loading = false;
      })
    },
    handleStartTimeChange() {
      if (this.form.endDate) {
        const startDate = new Date(this.form.startDate);
        const maxDate = new Date(startDate);
        maxDate.setMonth(startDate.getMonth() + 1);
        const endDate = new Date(this.form.endDate);
        if (endDate.getTime() > maxDate.getTime()) {
          this.form.endDate = '';
        }
      }
    },
  
  },
  mounted() {
    this.query.reconType = '1';
  },
};
</script>

<style lang="scss" scoped>
.tableTotal {
    border: 1px solid #ccc !important;
    padding: 10px;
    display: flex;
    font-size: 14px;
    color: #606166;
    div{
      flex: 6;
      display: flex;
      justify-content: space-around;
    }
  }
</style>
